
// Vue
import { Component, Vue } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action, State } from "vuex-class";

// Types
import { UserPermissions, FeaturesList } from "@/store/types";
import { ISyncSystem } from '../store/sync/types';

// Third Party
import { get } from "lodash";

// Components
import NavHeader from "@/components/NavHeader.vue";
import SyncSystem from "@/components/setup/contact-business-sync/SyncSystem.vue";
import SiteSync from "@/components/setup/contact-business-sync/SiteSync.vue";

// Namespaces
const Sync = namespace("sync");

@Component({
	components: {
		"nav-header": NavHeader,
		"sync-system": SyncSystem,
		"site-sync": SiteSync,
	}
})
export default class SyncSetup extends Vue {
	@State featuresList: FeaturesList;

	@Sync.Action getSyncSystems: (index: number, pageSize: number) => Promise<void>;
	@Sync.Mutation resetState: () => void;

	@Sync.State syncSystem: ISyncSystem[];
	@Sync.State syncSystemPageIndex: number;
	@Sync.State syncSystemPageSize: number;

	private tabIndex: number = 0;

	public async mounted() {
		await this.getSyncSystems(this.syncSystemPageIndex, this.syncSystemPageSize);
	}

	public beforeDestory() {
		this.resetState();
	}

	public get canViewSyncSetup(): boolean {
		return get(this.featuresList, ["Sync"]);
	}

}
